<template>
<div id="g-page" >
  
  <table border="0" class="main-table-screen" >
    <tr>
      <td id="main-table-row1" colspan="3"> 
      </td>
    </tr>
    <tr>
      <td></td>
      <td id="main-table-row2-dialog-container-td">
        <table border="0" class="dialog-table-radius">
            <tr>
              <td id="dialog-change-password" colspan="2" align="left" >
                <table>
                  <td id="dialog-change-password-title" colspan="2">
                  {{ $t("changepassword.changepassword") }}
                  </td>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="1" class="dialog-input-field-left">
                 {{ $t("changepassword.oldpassword") }}&nbsp;
              </td>
              <td class="dialog-input-field-right">
                &nbsp;<input type="password" ref="password" name="password" v-model="input.originalPassword" v-bind:placeholder="$t('changepassword.changepassword')" maxlength="40" />
              </td> 
            </tr>
            <tr>
              <td colspan="1" class="dialog-input-field-left">
                  {{ $t("changepassword.newpassword") }}&nbsp;
              </td>
              <td class="dialog-input-field-right">
                &nbsp;<input type="password" name="password" v-model="input.password" v-bind:placeholder="$t('changepassword.newpassword')" maxlength="40" />
              </td> 
            </tr>
            <tr>
              <td colspan="1" class="dialog-input-field-left">
                  {{ $t("changepassword.confirmpassword") }} &nbsp;
              </td>
              <td class="dialog-input-field-right">
                &nbsp;<input type="password" name="password" v-model="input.retypePassword" v-bind:placeholder="$t('changepassword.confirmpassword')" maxlength="40" />
              </td> 
            </tr>
            <tr>
              <td id="dialog-connect-td" colspan="2" >
                <!--<VueLoadingButton
                  aria-label="button"                  
                  class="default-styles dialog-connect-input"
                  :loading="isLoading"
                  :styled="true"
                  @click.native="login" >{{ $t("signon.connect") }} </VueLoadingButton>-->

                <input type="button" class="dialog-connect-input" v-on:click="cancel()"  v-bind:value="$t('changepassword.cancel')">
                &nbsp;
                <input type="button" class="dialog-connect-input" v-on:click="changePassword()" v-bind:value="$t('changepassword.changepassword')">
              </td>
            </tr>
          </table>

      </td>
      <td >
      </td>
    </tr>
    <tr>
      <td id="main-table-row3" colspan="3" > 
      </td>
    </tr>
  </table>
</div>
</template>

<script>

//import { API } from '../../../api/member-api'
const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
import messageBox from './../common/message-box'
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

export default {
  name: 'change-password',
  components: { },
  data() {
      return {
          input: {
              originalPassword: "",
              password: "",
              retypePassword: "",
              isProcessing: false
          }
      }
  },
  methods: 
  {
    onEnterClicked : function(event)
    {
      if (event.keyCode === 13) {
        // ADD ENTER KEY HANDLER FOR VIEW
        this.login();
      }
    },
    addEvents()
    {
      // RE-ADD EVENT HANDLER FOR ENTER KEY
      document.onkeyup = null;
      document.onkeyup = this.onEnterClicked;
    },
    cancel()
    {
      API.logoff(window.sessionKey);
      window.sessionKey = '';
      
      this.$router.push( { path: "/"} );
    },
    validatePassword(password)
    {
      var hasUpper = false;  
      var hasLower = false;
      var hasDigit = false;
      var hasPunctuation = false;
      var pass = false;

      var punctuations = [".", ",", ":", "!", "?", "@", "#"];
      try
      {
        for (var i = 0; i < password.length; i++)
        {
          var c = password[i];

          if (c.toUpperCase() == c)
          { 
              hasUpper = true;
          }
          
          if (c.toLowerCase() == c)
          { 
              hasLower = true;
          }
          
          if (Number.isInteger(parseInt(c)))
          {
              hasDigit = true;
          }
          
          if (punctuations.indexOf(c) > -1)
          {
              hasPunctuation = true;
          }
        }
        
        if (hasUpper &&
            hasLower &&
            hasDigit &&
            hasPunctuation)
        {
          
            pass = true;
        }
        //alert('u=' + hasUpper + ' l=' + hasLower + ' d=' + hasDigit + ' p=' + hasPunctuation);
        return pass;
      }
      catch
      {
        return false;
      }
    },
    changePassword() 
    {
      // CHANGE PASSWORD
      if(this.input.isProcessing == true)
      {
        // ELIMINATE DUPLICATE CLICKS OR ENTER KEY STROKES
        return;
      }
      this.input.isProcessing = true;

      // CHECK ORIGINAL PASSWORD
      if(this.input.originalPassword == "")
      {
        document.onkeyup = null;
        this.$generalMessage(messageBox, "You must enter your old password.", this.addEvents);
        this.input.isProcessing = false;
        return;
      }
      // CHECK NEW PASSWORD
      if(this.input.password == "")
      {
        document.onkeyup = null;
        this.$generalMessage(messageBox, "You must enter a new password.", this.addEvents);
        
        this.input.isProcessing = false;
        return;
      }
      // CHECK RETYPE PASSWORD
      if(this.input.retypePassword == "")
      {
        document.onkeyup = null;
        this.$generalMessage(messageBox, "You must retype your new password.", this.addEvents);
        this.input.isProcessing = false;
        return;
      }
      // CHECK PASSWORD LENGTH
      if(this.input.password.length < 8)
      {
        document.onkeyup = null;
        this.$generalMessage(messageBox, "Your password must be at least 8 characters long.", this.addEvents);
        this.input.isProcessing = false;
        return;
      }
      // CHECK PASSWORD CHARACTERS
      if(!this.validatePassword(this.input.password))
      {
        document.onkeyup = null;
        this.$generalMessage(messageBox, "Password must contain: Lower Case, Upper Case, Number and Punctuation Symbol.", this.addEvents);
        this.input.isProcessing = false;
        return;
      }

      // CHECK RETYPE
      if(this.input.password != this.input.retypePassword)
      {
        document.onkeyup = null;
        this.$generalMessage(messageBox, "Your new password and confirmation password do not match.", this.addEvents);
        this.input.isProcessing = false;
        return;
      }

      /* if(this.input.username != "" && this.input.password != "") 
      { */
        
        /* MAKE SIGNON CALL HERE */      
        API.changePassword(window.sessionKey, 
                          this.input.originalPassword, 
                          this.input.password,
                          this.$i18n.locale)
        .then(response => {          
          if(response.data.hasError == false)
          {
            document.onkeyup = null;
            this.$generalMessage(messageBox, "Your password was changed successfully.", this.addEvents);

            // REDIRECT TO THE MEMBER HOME PAGE
            //this.$router.push( { path: "/members/c19-daily-questionnaire"} );
            if(window.defaultDailyQuestionnaireTypeId == 1) // COVID
            {
              this.$router.push( { path: "/members/c19-daily-questionnaire"} );
            }
            else if(window.defaultDailyQuestionnaireTypeId == 2) // FIT FOR DUTY
            {
              this.$router.push( { path: "/members/daily-questionnaire"} );
            }
            else if(window.defaultDailyQuestionnaireTypeId == 3)  // DASHBOARD
            {
              this.$router.push( { path: "/members/dashboard"} );
            }
          } 
          else 
          {
            // FAILED TO AUTHENTICATE            
            document.onkeyup = null;
            this.$generalMessage(messageBox, response.data.errorMessage, this.addEvents);
            this.input.isProcessing = false;
            if(response.data.errorId == "4000")
            {
              window.sessionKey = '';
              SUPPORT.clearSession();
              this.$router.push( { path: "/"} );
              this.input.isLoading = false;
              return;
            }
          }
        })
        .catch(e => {
          alert('in catch');
          // NON API ERROR
          window.sessionKey = '';
          document.onkeyup = null;
          this.$generalMessage(messageBox, e, this.addEvents);
          this.input.isProcessing = false;
        });  
     /*  }
      else
      {
        // MISSING CREDENTIAL INFORMATION
        if(this.input.username == "")
        {
          document.onkeyup = null;
          this.$generalMessage(messageBox, "You must enter a username.", this.addEvents);
        }
        else if(this.input.password == "")
        {
          document.onkeyup = null;
          this.$generalMessage(messageBox, "You must enter a password.", this.addEvents);
        }
      } */
    },
    focusInput() {
      // SET DEFAULT CONTROL
      this.$refs.password.focus();
    }
  },  
  mounted () {

    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);

    let menuLogoff = document.getElementById('menuLogoff');
    //let menuSignon = document.getElementById('menuSignon');
    let menuMember = document.getElementById('menuMember');
    let menuMedicalHistory = document.getElementById('menuMedicalHistory');
    let menuCOVID19Questionnaire = document.getElementById('menuCOVID19Questionnaire');
    let menuMedicalTests = document.getElementById('menuMedicalTests');
    let menuAppointments = document.getElementById('menuAppointments');
    let menuOptionalConsents = document.getElementById('menuOptionalConsents');
    
    menuLogoff.classList.remove('is-hidden');
    menuMember.innerHTML = '<span v-on:click="toggleMenus" style="white-space:pre">Hi ' + window.firstName + '</span>'
    //menuSignon.classList.add('is-hidden');
    menuMedicalHistory.classList.add('is-hidden');
    menuCOVID19Questionnaire.classList.add('is-hidden');
    menuMedicalTests.classList.add('is-hidden')
    menuAppointments.classList.add('is-hidden')
    menuOptionalConsents.classList.add('is-hidden');

    //if(window.sessionKey == '')
    //{
      /* CURRENTLY LOGGED IN SO BYPASS LOGON
       * AND GO TO THE MEMBER HOME PAGE */
    //  this.$router.push( { path: "/members/signon"} );
    //  return;
    //}

    // ADD THE INITIAL ENTER KEY HANDLER
    document.onkeyup = this.onEnterClicked;

    // FOCUS ON THE USER NAME
    this.focusInput();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // BEGIN SIGNON DIALOG STYLES
  .main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:52px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:90%;
    padding-left: 10%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-change-password
  {
    height:52px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 15pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  
  #dialog-change-password-title
  {
    vertical-align:bottom;
    padding-left:8px
  }
  .dialog-input-field-left
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
  }
  .dialog-input-field-right
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
  }
  #dialog-connect-td
  {
    height: 50px;
    width:100%;
    vertical-align: middle !important;
    text-align: center;
    background-color:#343F68 ;
    //padding-right: 20px;
    padding-top: 15px;
  }
  .dialog-connect-input
  {
    color:white;
    //background-color:#4682B4 ; 
    background-image: linear-gradient(#4682B4,#4682B4);
    vertical-align: middle !important;   
  }
  #main-table-row3
  {
    height:250px;
  }
  
  
  // END SIGNON DIALOG STYLES
}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  // BEGIN SIGNON DIALOG STYLES
  .main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:150px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:33%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-change-password
  {
    height:40px;
    width:400px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 15pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  
  #dialog-change-password-title
  {
    vertical-align:bottom;
    padding-left:8px
  }
  .dialog-input-field-left
  {
    height:50px;
    width:45%;
    text-align: right !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
    //width:15%;
  }
  .dialog-input-field-right
  {
    height:50px;
    width:55%;
    text-align: left !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
  }
  #dialog-connect-td
  {
    height: 50px;
    vertical-align: middle;
    text-align: right;
    background-color:#343F68 ;
    padding-right: 20px;
  }
  .dialog-connect-input
  {
    color:white;
    background-color:#4682B4 ;   
    vertical-align: middle !important;
  }
  #main-table-row3
  {
    height:250px;
  }
  
  // END SIGNON DIALOG STYLES

}
</style>